<template>
  <div class="service__types w-100 my-2">
    <div
      v-if="withTopPositionButtons && withTopPositionButtons.length"
      class="d-flex flex-wrap my-3"
      :class="{ 'justify-content-center': !isNewDesign }"
    >
      <div v-for="(chip, index) in withTopPositionButtons" :key="index">
        <button
          :title="chip.displayName"
          :disabled="isWaitingForResponse"
          class="btn mb-2 rounded-buttons mx-1 text-white chips__btn px-4"
          :class="[
            { 'px-4 py-2': isNewDesign },
            { 'bgcolor-primary': !isGradient },
            { 'transparent-bgcolor': isGradient },
          ]"
          @click="optionclick($event, chip)"
        >
          {{ chip.displayName }}
        </button>
      </div>
    </div>
    <template v-if="withOutPositionButtons != null && withOutPositionButtons.length > 5">
      <VSlickCarousel ref="slick" class="service__types__list px-3 my-3" v-bind="slickOptions">
        <template #nextArrow="arrowSlotProps">
          <em
            :disabled="arrowSlotProps.disabled"
            @click="arrowSlotProps.onClick"
            class="primaryicon-right-arrow"
            :style="getArrowStyles('right')"
          ></em>
        </template>
        <template #prevArrow="arrowSlotProps">
          <em
            :disabled="arrowSlotProps.disabled"
            @click="arrowSlotProps.onClick"
            class="primaryicon-left-arrow"
            :style="getArrowStyles('left')"
          ></em>
        </template>
        <div
          v-for="(chip, index) in withOutPositionButtons"
          :key="index"
          class="service__types__list__item p-1 text-center"
        >
          <div
            :title="chip.name"
            :disabled="isWaitingForResponse"
            class="btn btn-block w-100 rounded-buttons p-1 text-white chips__btn"
            :class="[
              { 'px-4 py-2': isNewDesign },
              { 'bgcolor-primary': !isGradient },
              { 'transparent-bgcolor': isGradient },
            ]"
            @click="optionclick($event, chip)"
          >
            {{ chip.displayName }}
          </div>
        </div>
      </VSlickCarousel>
    </template>
    <div v-else class="d-flex flex-wrap my-3" :class="{ 'justify-content-center': !isNewDesign }">
      <div v-for="(chip, index) in withOutPositionButtons" :key="index">
        <button
          :title="chip.displayName"
          :disabled="isWaitingForResponse"
          class="btn mb-2 rounded-buttons mx-1 text-white chips__btn px-4"
          :class="[
            { 'px-4 py-2': isNewDesign },
            { 'bgcolor-primary': !isGradient },
            { 'transparent-bgcolor': isGradient },
          ]"
          @click="optionclick($event, chip)"
        >
          {{ chip.displayName }}
        </button>
      </div>
    </div>
    <div
      v-if="withBottomPositionButtons && withBottomPositionButtons.length"
      class="d-flex flex-wrap my-3"
      :class="{ 'justify-content-center': !isNewDesign }"
    >
      <div v-for="(chip, index) in withBottomPositionButtons" :key="index">
        <button
          :title="chip.displayName"
          :disabled="isWaitingForResponse"
          class="btn mb-2 rounded-buttons mx-1 text-white chips__btn px-4"
          :class="[
            { 'px-4 py-2': isNewDesign },
            { 'bgcolor-primary': !isGradient },
            { 'transparent-bgcolor': isGradient },
          ]"
          @click="optionclick($event, chip)"
        >
          {{ chip.displayName }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { chatWidgetSuggestionsInteraction } from "../../../Events/TagManagerServices/TaggingEventForPages.js";
// import { mapState } from "vuex";
// import store from "../../../../../store/store";
// import { SET_CHAT_ACTIONS } from "../../../../../store/StoreConstants/CommonSettingsConstants";
import "v-slick-carousel/style.css";
import { VSlickCarousel } from "v-slick-carousel";
import { RECENT_VDP_VIN_KEY } from "../../../../../js/constants/constants.js";
import { useChatSettingsStore } from "../../../store/ChatSettingsStore/ChatSettingsStore";
export default {
  components: {
    VSlickCarousel,
  },
  data() {
    return {
      buttons: [],
      isDisableChat: false,
      themePrimaryColor: window.primaryColor,
      slickOptions: {
        infinite: false,
        slidesPerGroup: 3,
        groupsToShow: 2,
        dots: true,
        // adaptiveHeight: false,
        // nextArrow: `<em class="primaryicon-right-arrow bgcolor-primary" style="cursor:pointer;right:0;top: 50%;transform: translateY(-50%);display: flex;justify-content: center;align-items: center;background:${this.themePrimaryColor} !important"></em>`,
        // prevArrow: `<em class="primaryicon-left-arrow bgcolor-primary" style="cursor:pointer;left:0;top: 50%;transform: translateY(-50%);display: flex;justify-content: center;align-items: center;;background:${this.themePrimaryColor} !important"></em>`,
      },
    };
  },
  computed: {
    // ...mapState({
    //   chatThemeSettings: (state) => {
    //     return state?.commonSettings?.chatThemeSettings;
    //   },
    // }),
    withOutPositionButtons() {
      const normalButtons = this.buttons.filter(
        (button) => button.position === undefined || button.position === null
      );
      return [...normalButtons];
    },
    withTopPositionButtons() {
      const topButtons = this.buttons.filter((button) => button.position === "top");
      return [...topButtons];
    },
    withBottomPositionButtons() {
      const bottomButtons = this.buttons.filter((button) => button.position === "bottom");
      return [...bottomButtons];
    },
    isGradient() {
      return this.chatThemeSettings?.isGradient ?? false;
    },
  },
  props: ["botResponse", "isWaitingForResponse", "chatThemeSettings", "isNewDesign"],
  mounted() {
    this.buttons = this.botResponse?.component?.values;
    if (this.chatThemeSettings?.primeColor) {
      this.themePrimaryColor = this.chatThemeSettings.primeColor;
    }
    this.scrollBottom();
  },
  methods: {
    optionclick(event, button) {
      console.log(button);
      const storeThemeSettings = useChatSettingsStore();
      storeThemeSettings.tvmChatActions = {
        ModeOfAction: "tvm-assistant-structured-suggestion-button",
      };
      let request = {
        UserResponse: button.displayName,
        Event: null,
        EventLabel: button.displayName,
        SubmitFlow: button.submitFlow,
        SubmitAction: button.submitAction,
        specialObject: { TvmComponentRequest: button },
      };
      if (request) {
        this.$emit("tvm-structured-suggestions", request);
      }
      chatWidgetSuggestionsInteraction(event, {});
    },
    scrollBottom() {
      let container = document.querySelector("#chat__bodyview");
      if (container) {
        setTimeout(() => {
          container.scrollTop = container.scrollHeight;
        }, 800);
      }
    },
    getArrowStyles(direction) {
      const commonStyles = {
        cursor: "pointer",
        top: "50%",
        transform: "translateY(-50%)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: this.themePrimaryColor,
        color: "#fff",
        fontSize: "10px",
        padding: "5px",
        zIndex: 10,
      };
      if (direction === "left") {
        return {
          ...commonStyles,
          left: "0",
          borderRadius: "0px 3px 3px 0px",
        };
      } else if (direction === "right") {
        return {
          ...commonStyles,
          right: "0",
          borderRadius: "3px 0px 0px 3px",
        };
      }
      return commonStyles;
    },
  },
};
</script>
<style scoped>
#chat-widget .rounded-buttons.chips__btn {
  font-size: 11px !important;
  font-weight: 400 !important;
  padding: 6px 12px !important;
  min-width: 56px !important;
  text-transform: unset !important;
  overflow: hidden;
  text-overflow: ellipsis;
}

@media (min-width: 1900px) {
  #chat-widget .rounded-buttons.chips__btn {
    font-size: 12px !important;
  }
}

.service__types >>> em.primaryicon-left-arrow.slick-disabled,
.service__types >>> em.primaryicon-right-arrow.slick-disabled {
  pointer-events: none;
  opacity: 0;
}

.search_bar {
  width: 100%;
  border: 0;
  background: #eee;
  border-radius: 30px;
  margin: auto;
  font-size: 12px;
  display: block;
  padding: 7px;
}

.search_bar:focus {
  outline: none;
}

.search_box_container {
  background: #eee;
  border-radius: 30px;
  padding: 0 10px;
}

.search_box_container em {
  font-size: 12px;
}

div[disabled="true"] {
  opacity: 0.6;
  pointer-events: none;
}
</style>
